import React, { useState , useCallback , useEffect } from "react";
import { Box, Grid } from "@mui/material";
import Header from "../../../Layouts/Components/Header";
import AlertSection from "./Alert/Section";
import NotificationSection from "./Notifications/Section";
import RightSideSetting from "./GeneralSettings/RightSideSetting";
import {  useFormik } from "formik";
import usePrompt from '../../Hooks/usePrompt'
import { useNavigate } from "react-router-dom";
import SaveChangesModal from '../../shared/SaveChangesModal'
import { useSelector , useDispatch  } from "react-redux";
import { getAlerts , resetAllAlerts , getConfiguration , getGroups } from "../state/actions";
import ScreenLoader from "../../shared/ScreenLoader";
import useSnackBar from "../../Hooks/useSnackBar";
import CustomerSection from "./CustomerSbuscriber/CustomerSection";
export const Alerts = () => {
  const Navigate = useNavigate();
const [touched, setTouched] = useState(false)
const { success, error, snackbar } = useSnackBar();
const [pendingLocation, setPendingLocation] = useState(null);
const [isConfirmationModalOpen,setIsConfirmationModalOpen] = useState(false)

const { Alerts , Notifications , configurationData , Groups , customerSub } = useSelector(
  (state) => state.alertAndNotifications
);

const dispatch = useDispatch();
const loadConfiguration = useCallback(
  () => dispatch(getConfiguration(error)),
  [dispatch, error]
);


const loadAlerts = useCallback(() => dispatch(getAlerts(true)), [dispatch]);
const laodGroups = useCallback(() => dispatch(getGroups(error)), [dispatch,error]);
const resetAlerts = useCallback(
  () => dispatch(resetAllAlerts()),
  [dispatch]
)
const handleBlockedNavigation = useCallback(
  (nextLocation) => {
    if (nextLocation.pathname === "/admin-tool/alerts-notifications") return true;
    if (touched) {
      setPendingLocation(nextLocation.pathname);
      setIsConfirmationModalOpen(true);
      return false;
    }
    return true;
  },
  [touched]
);

useEffect(() => {
  loadAlerts();
  laodGroups()
  loadConfiguration();
  return () => {
    resetAlerts();
  };
}, [loadAlerts, resetAlerts,loadConfiguration,laodGroups]);

//close navigation blocker handler
const handleCloseConfirmationModal = () => {
  setIsConfirmationModalOpen(false);
  setPendingLocation(null);
};

//discard changes action handler
const handleDiscardChanges = () => {
  setIsConfirmationModalOpen(false);
  setTouched(false);
};


//navigate to pendingLocation effect
useEffect(() => {
  if (pendingLocation && !touched) Navigate(pendingLocation);
}, [Navigate, pendingLocation, touched]);

usePrompt(handleBlockedNavigation,touched)
const formik = useFormik({
  enableReinitialize:true,
  initialValues:{
    clientId:"",
    warningMail:"",
    waterMark:true,
    customerFile:"",
    branchFile:"",
    timeOption:"",
    limitOption:"",

  },
  onSubmit: (values) => {
    console.log(values)
  },
})


  return (
    <div>
      {snackbar}
<SaveChangesModal
        open={isConfirmationModalOpen}
        onClose={handleCloseConfirmationModal}
     
        discardChanges={handleDiscardChanges}
        saveChanges={formik.handleSubmit}
      />
    
      <Header headLine="Alert & Notifications">
      </Header>

    
{Notifications && Alerts && customerSub ? 
<Box
sx={{
  backgroundColor: "#F8FAFB",
  paddingLeft: "30px",
  paddingRight: "30px",
  paddingTop: "50px",
  paddingBottom: "30px",
}}
>
<Grid container spacing={2} sx={{ marginBottom: "50px" }}>
  <Grid item md={8} xs={12}>
    <AlertSection
      sectionName={"Email/SMS Template for Alerts"}
      sectionAlerts={Alerts}
     success={success}
     error={error}
    />

    <NotificationSection
      sectionName={"Email/SMS Template For Customer Notifications"}
      sectionNotification={Notifications}
      success={success}
      error={error}
    />


 <CustomerSection
  sectionName={"Template For Subscription Notifications"}
  sectionSubscribers={customerSub}
  success={success}
  error={error}
  /> 
  </Grid>



  <Grid item  md={4} xs={12}>
    <RightSideSetting
     formik={formik} setTouched={setTouched} success={success}
      error={error}
      configurationData={configurationData}
      Groups={Groups}
      touched={touched}
      />
    
  </Grid>
</Grid>
</Box> : <ScreenLoader/>} 


    </div>
  );
};
